module.exports = __webpack_public_path__ + "static/img/nav1.06e2d98.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/nav1.png
// module id = 32fb
// module chunks = 1